import { Navigate, Outlet } from 'react-router-dom';
import useAuthStore from '@/store/authStore';

export default function LogistaRoute() {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) return <Navigate to="/logista/login" replace />;
  if (user?.role !== 'partner') return <Navigate to="/" replace />;

  return <Outlet />;
}
